import { number } from 'prop-types';
import React from 'react';
import { Badge } from 'reactstrap';

function DistributionShareTotal({ total }) {
  let color = 'success';
  if (total > 100) {
    color = 'danger';
  } else if (total < 100) {
    color = 'warning';
  }
  return <Badge color={color}>Total distribution - {total}%</Badge>;
}

DistributionShareTotal.propTypes = {
  total: number.isRequired,
};

export default DistributionShareTotal;
